var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _rect, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 64,
    r: 11,
    fill: "#E8F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.369 44.1L154.129 40L158.219 41.76L156.469 45.86L152.369 44.1Z",
    fill: "#001729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.88 130.83L131.88 127.48",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 121.53L125.9 130.08",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.87 142.86L118.36 151.33L114.72 134.24L105.72 152.79L89.5196 148.23L94.7296 160L80.8096 164.25L106.19 173.14L100.92 185.39L110.92 178.69L123.06 186.69L123.12 176.91L139 172.57L127.41 163.18L138.87 142.86Z",
    fill: "#1E6EE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.254 87.4102L151.294 102.228L161.193 108.213L170.152 93.3954L160.254 87.4102Z",
    fill: "#E8F5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.44 68.3201C177.189 68.3201 177.922 68.0978 178.545 67.6814C179.168 67.2649 179.654 66.673 179.941 65.9805C180.228 65.288 180.303 64.5259 180.157 63.7907C180.011 63.0555 179.65 62.3802 179.12 61.8502C178.589 61.3201 177.914 60.9592 177.179 60.8129C176.444 60.6667 175.682 60.7418 174.989 61.0286C174.297 61.3155 173.705 61.8012 173.288 62.4245C172.872 63.0478 172.65 63.7805 172.65 64.5301C172.65 65.5353 173.049 66.4993 173.76 67.2101C174.47 67.9208 175.434 68.3201 176.44 68.3201Z",
    fill: "white",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.8 17.1101C186.175 17.1101 186.543 16.9986 186.855 16.7899C187.168 16.5811 187.411 16.2843 187.555 15.9372C187.699 15.59 187.736 15.208 187.663 14.8394C187.59 14.4708 187.409 14.1323 187.143 13.8666C186.877 13.6008 186.539 13.4199 186.17 13.3466C185.802 13.2733 185.42 13.3109 185.072 13.4547C184.725 13.5985 184.429 13.842 184.22 14.1545C184.011 14.4669 183.9 14.8343 183.9 15.2101C183.9 15.714 184.1 16.1972 184.456 16.5536C184.812 16.9099 185.296 17.1101 185.8 17.1101Z",
    fill: "#1E6EE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.21 17L81 19.86",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.07 87.6498L99.64 108.65L98.25 104.75L155.69 83.7498L157.07 87.6498Z",
    fill: "#1E6EE7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.58 67.3099L101.68 88.6899L100 84.9999L145.9 63.6199L147.58 67.3099Z",
    fill: "#E8F5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.529 47.2301L90.7893 56.4301L90.0293 52.4301L139.819 43.1501L140.529 47.2301Z",
    fill: "#E8F5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8557 39.4035C93.5723 39.1907 94.2098 38.7703 94.6875 38.1953C95.1652 37.6204 95.4617 36.9167 95.5395 36.1732C95.6173 35.4297 95.4729 34.6799 95.1246 34.0185C94.7763 33.357 94.2397 32.8138 93.5826 32.4573C92.9256 32.1008 92.1776 31.9471 91.4332 32.0157C90.6888 32.0843 89.9815 32.372 89.4007 32.8426C88.8198 33.3131 88.3915 33.9453 88.1699 34.6592C87.9483 35.3731 87.9434 36.1367 88.1557 36.8535C88.2968 37.3296 88.5302 37.7732 88.8428 38.1591C89.1554 38.545 89.5409 38.8654 89.9774 39.1022C90.4138 39.3391 90.8927 39.4875 91.3866 39.5392C91.8804 39.5909 92.3797 39.5448 92.8557 39.4035Z",
    fill: "white",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.16 87.3701C166.876 87.158 167.514 86.7383 167.992 86.164C168.47 85.5897 168.767 84.8866 168.846 84.1435C168.924 83.4004 168.781 82.6507 168.434 81.989C168.086 81.3274 167.551 80.7835 166.895 80.4261C166.238 80.0686 165.491 79.9137 164.747 79.9809C164.003 80.048 163.295 80.3343 162.713 80.8034C162.132 81.2726 161.702 81.9035 161.479 82.6167C161.256 83.3298 161.249 84.0931 161.46 84.8101C161.745 85.772 162.399 86.5816 163.28 87.0615C164.162 87.5413 165.197 87.6523 166.16 87.3701Z",
    fill: "#1E6EE7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.549 154L118.239 157.36",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7296 99.9301L97.0196 100.93",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139 48.2302L137.54 51.3502",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.579 56.09L143.869 56.01",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 145.05L36.8398 147.78",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.74 89.62C42.63 89.72 42.44 89.85 42.32 89.96C39.32 92.57 36.18 95.65 35.03 99.56C34.8267 100.301 34.7027 101.062 34.66 101.83C31.3056 101.428 28.0412 100.471 25 99C25 98.84 25 98.77 25 98.61C26.17 92.76 29.61 88.02 33.8 84.03C34.61 83.27 35.43 82.5 36.27 81.81C36.5562 81.5657 36.8642 81.3481 37.19 81.16C37.9 80.7782 38.698 80.5901 39.5038 80.6147C40.3095 80.6393 41.0946 80.8756 41.78 81.3C44.53 83.06 45.86 87.06 42.74 89.62Z",
    fill: "#001729",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1396 58.38C74.1396 66.14 70.0696 73.21 63.9696 77.76C57.3796 82.69 49.1496 84.6 42.6996 89.7C42.5796 89.81 42.4396 89.85 42.3196 89.96C38.3196 92.65 33.6796 88.42 34.5596 84.59C34.8181 83.5442 35.4424 82.6254 36.3196 82C36.6196 81.76 36.9896 81.5 37.3196 81.26C38.7396 80.26 40.1896 79.37 41.6496 78.5C45.8596 76.14 50.3296 74.37 54.5496 72.01C58.7696 69.65 63.9296 65.44 63.2396 59.84C63.2396 59.54 63.2396 59.25 63.2396 59.02C66.4996 58.43 69.6396 57.73 72.8496 57.02C72.9812 57.4652 73.0781 57.9199 73.1396 58.38Z",
    fill: "#001729",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2296 59.89C62.5696 55.62 61.2296 52.98 61.6996 51.89C62.1696 50.8 63.0496 53.94 64.3396 54.01C65.6296 54.08 63.4196 49.14 64.8096 48.29C66.1996 47.44 66.9296 52.2 66.9296 52.2C66.9296 52.2 65.9296 47.96 67.1096 47.76C68.2896 47.56 68.9296 52 68.9296 52C68.9296 52 68.3996 47.69 69.0796 47.71C69.7596 47.73 71.4496 49.17 73.1396 58.42",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2296 59.89C62.5696 55.62 61.2296 52.98 61.6996 51.89C62.1696 50.8 63.0496 53.94 64.3396 54.01C65.6296 54.08 63.4196 49.14 64.8096 48.29C66.1996 47.44 66.9296 52.2 66.9296 52.2C66.9296 52.2 65.9296 47.96 67.1096 47.76C68.2896 47.56 68.9296 52 68.9296 52C68.9296 52 68.3996 47.69 69.0796 47.71C69.7596 47.73 71.4496 49.17 73.1396 58.42",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3398 54.0603C65.5512 54.3233 66.6495 54.9598 67.4799 55.8803L64.3398 54.0603Z",
    fill: "#001729"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3398 54.0603C65.5512 54.3233 66.6495 54.9598 67.4799 55.8803",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.81 76.0001C122.81 76.0001 131.42 77.9301 133.21 78.6601L137.39 59.0001C137.39 59.0001 131.21 58.5201 130.13 63.1601L122.31 62.4201L122.81 76.0001Z",
    fill: "#001729",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M130.19 63.1803L130.09 66.1103",
    stroke: "white",
    strokeWidth: 0.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.549 62.92L128.159 65.92",
    stroke: "white",
    strokeWidth: 0.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6996 162.76C93.6996 162.76 92.5796 169.76 92.0996 171.76L112.1 173.44C112.1 173.44 111.77 167.29 107.1 166.81L106.8 159.01L93.6996 162.76Z",
    fill: "#001729",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.08 166.69L104.18 166.95",
    stroke: "white",
    strokeWidth: 0.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.18 165L104.18 165.06",
    stroke: "white",
    strokeWidth: 0.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.54 163.25C89.54 136.5 69.3399 120.9 50.0699 117.44C44.0699 116.38 44.1699 111.6 46.5499 107.54C46.359 105.961 46.5795 104.359 47.1899 102.89C59.3499 71.4603 95.38 55.5303 126.19 61.6903L122.9 77.7703C99.4399 73.2403 72.8999 81.8903 61.4599 104.26C84.5499 110.26 108.09 130 108.32 161.04C103.18 161.82 96.43 162.17 91.54 163.25Z",
    fill: "white",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.16 160.45L107.59 157.31",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.44 61.3806L119.52 77.0006",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4196 121.07L12.3096 124.07L14.6096 143.86L40.7196 140.81L38.4196 121.07Z",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8896 128.5L19.2096 139.8",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9092 130.94L22.9992 139.42",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3596 109.45L29.5196 134.53L48.5196 140.47L56.3696 115.39L37.3596 109.45Z",
    fill: "white",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1191 130.11L45.9991 133.53",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3398 126.18L47.1798 129.6",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0792 96.34L46.4592 112C46.0869 112.277 45.6222 112.399 45.162 112.341C44.7018 112.283 44.2817 112.05 43.9892 111.69L32.9992 97.32C32.7203 96.9486 32.5967 96.4832 32.6546 96.0223C32.7124 95.5614 32.9472 95.141 33.3092 94.85L53.9992 79.16C54.3723 78.8805 54.8392 78.7566 55.3018 78.8144C55.7644 78.8723 56.1865 79.1073 56.4792 79.47L67.4792 93.87C67.6246 94.0549 67.7301 94.2679 67.7889 94.4955C67.8478 94.7232 67.8588 94.9606 67.8212 95.1928C67.7836 95.4249 67.6982 95.6468 67.5705 95.8442C67.4428 96.0417 67.2755 96.2105 67.0792 96.34Z",
    fill: "white",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9091 92.9998L47.5791 94.7798L49.4491 97.2198L51.7691 95.4398L49.9091 92.9998Z",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3396 111.46C41.7196 126.74 45.9596 120.46 51.5596 120.71C57.1596 120.96 53.6796 137.2 54.4796 150C55.3696 163.36 70.7196 141.7 76.3796 147.25C82.2396 152.96 57.1196 174.59 35.2596 181.25",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4199 97.1299L56.6299 79.4099",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2498 101.66L37.8198 104C37.6941 104.118 37.5454 104.208 37.3831 104.266C37.2207 104.324 37.0482 104.347 36.8764 104.335C36.7046 104.323 36.5371 104.275 36.3845 104.195C36.232 104.115 36.0976 104.004 35.9898 103.87C34.9998 102.86 36.2498 101.66 36.2498 101.66Z",
    fill: "#001729"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4396 101.88C58.898 100.338 57.2757 98.8798 55.5796 97.5101C52.0996 103.89 45.4996 112.51 37.8496 108.33C34.9196 106.74 34.2896 103.33 34.8496 100.33C31.8496 98.7601 28.8496 97.1201 25.9596 95.4401C25.5604 96.4908 25.2559 97.5751 25.0496 98.6801C23.6896 105.41 26.1396 112.95 32.2096 116.59C38.2796 120.23 45.8296 119.86 51.9296 116.27C56.7496 113.43 60.2096 109.27 62.9996 104.59C62.1696 103.67 61.2896 102.74 60.4396 101.88Z",
    fill: "#001729",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5791 97.5103C58.8991 91.6103 60.8691 88.9503 59.8891 93.1803C59.3191 95.8103 60.5591 94.4703 62.6091 91.5603C64.6591 88.6503 63.8191 93.1403 63.1491 94.9003C63.1491 94.9003 65.1491 91.1103 66.1491 91.6403C67.1491 92.1703 65.0891 96.1203 65.0891 96.1203C65.0891 96.1203 67.1891 92.3703 67.8891 93.5003C68.4691 94.5003 64.1991 102.19 62.9891 104.63",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5791 97.5103C58.8991 91.6103 60.8691 88.9503 59.8891 93.1803C59.3191 95.8103 60.5591 94.4703 62.6091 91.5603C64.6591 88.6503 63.8191 93.1403 63.1491 94.9003C63.1491 94.9003 65.1491 91.1103 66.1491 91.6403C67.1491 92.1703 65.0891 96.1203 65.0891 96.1203C65.0891 96.1203 67.1891 92.3703 67.8891 93.5003C68.4691 94.5003 64.1991 102.19 62.9891 104.63",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7396 70.11L40.2196 69.22C39.169 68.3769 37.9473 67.7729 36.6396 67.45C34.1296 66.78 30.6396 69.53 32.4396 72.64C32.998 73.7876 33.9805 74.6732 35.1796 75.11L35.9396 82.47L34.0496 84.15C34.2542 84.3272 34.4752 84.4845 34.7096 84.62C35.2822 84.9655 35.9228 85.1828 36.5874 85.2571C37.252 85.3313 37.9249 85.2607 38.5596 85.05C39.4227 84.8497 40.2083 84.4011 40.8196 83.7596C41.4308 83.1181 41.841 82.3118 41.9996 81.44C42.1785 80.4677 42.0886 79.465 41.7396 78.54C41.1694 78.8333 40.6213 79.1675 40.0996 79.54L39.3996 73.87C39.8783 73.377 40.1733 72.7346 40.2352 72.0502C40.2971 71.3658 40.1221 70.6809 39.7396 70.11Z",
    fill: "white",
    stroke: "#001729",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1692 67.37C37.1692 68.65 35.5592 70.6 34.6892 71.45C34.0592 72.09 34.8492 72.97 35.5992 72.75C36.3492 72.53 35.7892 74.4 35.5092 74.75L35.1592 75.08C34.1592 74.86 33.2292 74.08 32.3292 72.56C30.5792 69.62 33.7792 62.57 36.1692 67.37Z",
    fill: "#001729"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4099 69.6803L35.0699 69.0003C34.88 68.9142 34.6656 68.8991 34.4655 68.9578C34.2654 69.0166 34.0931 69.1452 33.9799 69.3203C33.9344 69.4168 33.9083 69.5213 33.9033 69.6279C33.8982 69.7345 33.9143 69.841 33.9505 69.9413C33.9867 70.0417 34.0424 70.1339 34.1144 70.2127C34.1864 70.2914 34.2732 70.3552 34.3699 70.4003L35.6999 71.1203C35.8913 71.2071 36.1074 71.2225 36.3091 71.1638C36.5109 71.1051 36.685 70.9762 36.7999 70.8003C36.8535 70.7022 36.8859 70.594 36.8951 70.4827C36.9043 70.3714 36.89 70.2593 36.8533 70.1538C36.8166 70.0483 36.7581 69.9517 36.6818 69.8701C36.6054 69.7885 36.5128 69.7239 36.4099 69.6803Z",
    fill: "#001729"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M163.779 32.6L119.329 32.13V28.53L163.779 29.01V32.6Z",
    fill: "#E8F5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.66602,
    y: 170.458,
    width: 30,
    height: 20.0465,
    transform: "rotate(-4.6065 9.66602 170.458)",
    fill: "#E8F5FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30.723 155L3 163.482L9.44861 184.505L37.1716 176.023L30.723 155Z",
    stroke: "#001729",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7207 162.576L23.3779 174.6",
    stroke: "#001729",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14.373 163.756L16.8973 171.147",
    stroke: "#001729",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6992 161.59L26.3564 173.614",
    stroke: "#001729",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fd1cc822a2f65aa48703b9f1f620e507.svg";
export { ForwardRef as ReactComponent };